import { createQuery, createSafeInvalidateQueries } from '../common';
import { getDimensions, getDimension } from '../apis';

async function queryDimensions() {
  const dimensions = await getDimensions();

  const dimensionMap = dimensions.reduce((acc, it) => {
    acc.set(it.id, it);
    return acc;
  }, new Map<string, (typeof dimensions)[0]>());

  const dimensionOptions = dimensions.map((it) => ({
    ...it,
    label: it.name,
    value: it.id,
    predefined: !!it.predefined,
    defaultPropagation: (it.predefined ? 'global' : 'context') as Propagation,
  }));

  return { dimensions, dimensionMap, dimensionOptions };
}

export const QUERY_KEY_DIMENSIONS = `/gm/v1/dimensions` as const;

export const useDimensions = createQuery({
  queryKey: [QUERY_KEY_DIMENSIONS],
  queryFn: queryDimensions,
  staleTime: Infinity,
  cacheTime: Infinity,
});

export const useDimension = createQuery((id: string) => ({
  queryKey: [QUERY_KEY_DIMENSIONS, id],
  queryFn: () => getDimension(id),
}));

export const invalidateDimensionsQuery = createSafeInvalidateQueries({
  queryKey: [QUERY_KEY_DIMENSIONS],
});
